import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { Router } from "@angular/router";
import { co } from "@fullcalendar/core/internal-common";
import { TranslateService } from "@ngx-translate/core";
declare let $: any;

@Component({
  selector: "app-confirm-modal",
  templateUrl: "./confirm-modal.component.html",
  styleUrls: ["./confirm-modal.component.scss"],
})
export class ConfirmModalComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() content: string;

  @Input() subtitle: string;

  @Input() attendanceErr: boolean = false;

  @Input() btnContent: string = "Delete";
  @Input() backBtnContent: string = "shared.back";
  @Input() btnStyle: string;
  @Input() id: string;
  @Input() truncate = true;
  @Input() showOkOnlyBtn: boolean = false;
  // < These properties are only for transfer member to another entity only>//
  @Input() translationModulesEnum: string;
  @Input() translationContent: string;
  @Input() entities: any;
  @Output() selectedEntity: EventEmitter<any> = new EventEmitter();
  @Input() resetSelectedEntity: boolean = false;
  changeEntity(event: any) {
    if (event) {
      this.selectedEntity.emit(event);
    }
  }

  // </ These properties are only for transfer member to another entity only >//
  //this part is to preview transaction information
  @Input() isPreviewMode: boolean = false;
  @Input() dataToPreview: any;
  //this part is to preview transaction information
  ///////////////////////////////////////////////////////
  // </ These properties are only for booking details >//
  @Input() BookingRequestPricingAction: boolean = false;
  @Input() bookingRequestId: string;
  bookingPrice: number;
  priceError: string = "";

  ///////////////////////////////////////////////////////

  @Output() confirm = new EventEmitter();
  @Output() rejectionReason = new EventEmitter();
  @Output() cancel = new EventEmitter();
  reason;
  lang: string;
  @Input() isLoading: boolean = false;

  constructor(
    public translate: TranslateService,

    private router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges): void {}

  ngOnInit(): void {
    this.lang = this.translate.currentLang;
    console.log("lang", this.lang);
  }
  validatePrice(event: any) {
    if (event.target.value < 0) {
      event.target.value = "";
      return;
    }
    if (event.target?.value === "0") {
      this.priceError =
        this.lang == "en"
          ? "Price cannot be zero"
          : "يجب ان تكون القيمة اكبر من الصفر";
    } else if (event.target?.value?.length > 7) {
      this.priceError =
        this.lang == "en"
          ? "Price must be equal or less than 7 digits"
          : "يجب أن يكون السعر مساويًا أو أقل من 7 أرقام";
    } else {
      this.priceError = "";
    }
  }
  modalconfirm() {
    if (
      this.BookingRequestPricingAction &&
      (this.bookingPrice <= 0 ||
        !this.bookingPrice ||
        String(this.bookingPrice)?.length > 7)
    ) {
      this.priceError =
        this.lang == "en"
          ? "Price cannot be zero or empty or more than 7 digits"
          : "لا يمكن أن يكون السعر صفرًا أو فارغًا أو أكثر من 7 أرقام";
      return;
    }
    this.isLoading = true;
    if (this.BookingRequestPricingAction) {
      const payload = {
        id: this.bookingRequestId,
        price: this.bookingPrice,
      };
      this.confirm.emit(payload);
      this.bookingPrice = null;
    } else {
      this.confirm.emit(this.reason);
    }
    $("#basicModalCenter").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    $("body").css("overflow", "auto");
  }

  onCancel() {
    this.cancel.emit();
    this.bookingPrice = null;
  }
}
